
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ship/[[...slug]]",
      function () {
        return require("private-next-pages/ship/[[...slug]].tsx");
      }
    ]);
  